import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ENDPOINT } from '@constants/endpoint';
import axios from '@utils/axiosInstance';

const getValidateDiscountCode = async ({ code, basket }) => {
  const response = await axios.get(ENDPOINT.VALIDATE_DISCOUNT_CODE, {
    params: { code, basket },
    errorHandle: false,
  });

  return response?.data ?? {};
};

const useValidateDiscountCode = () => {
  const queryClient = useQueryClient();

  const query = useMutation({
    mutationFn: getValidateDiscountCode,
    onSuccess: response => {
      queryClient.setQueryData(['discountCode'], () => response);
    },
  });

  return query;
};

export default useValidateDiscountCode;
